<template>
  <div>
    <multiselect
      class="multiselector"
      v-model="value"
      :options="listOptions"
      :label="listLabel"
      :track-by="listValue"
      placeholder=""
      :clear-on-select="true"
      :show-labels="false"
      :multiple="false"
      :internal-search="!hasMore"
      :loading="isLoading"
      @search-change="search"
    >
      <span slot="noOptions">{{ this.noOptionsMsg }}</span>
      <template slot="option" slot-scope="props" v-if="listLabel=='admin4_name'">
        <span class="w-full" :title="props.option.admin3_name + ' - ' + props.option.admin4_name">
          {{props.option.admin4_name}}
        </span>
      </template>

    </multiselect>

    <!-- simple way to get the admin1_name from outside JS for TOT Expense Report forms -->
    <div style="display: none;" id="vue-hidden-region-value">{{ admin1_name }}</div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect"
import siloCalloutService from '@services/siloCalloutService'
import { debounce } from 'lodash-es'

export default {
  name: "silo-select",
  components: {
    Multiselect,
  },
  data() {
    return {
      listOptions: [],
      isLoading: false,
      searchFor: "",
      lastFilter: "",
      hasMore: false,
      value: {},
      initiliazed: false,
    }
  },
  computed: {
    listLabel() {
      return "admin" + this.level + "_name"
    },
    listValue() {
      return `admin${ this.level }_${ this.valueField }`
    },
    filter() {
      //let f = `level=${this.level}&country_code=${this.countryCode}&part_of=${this.partOf}&search=${this.searchFor}`
      let f = {
        level: this.level,
        country_code: this.countryCode,
        part_of: this.partOf,
        search: this.searchFor,
      }
      if (this.byPoint) {
        f.point = this.partOf 
      }
      return f
    },
    admin1_name() {
      return this.value && this.value.admin1_name
    },
    noOptionsMsg() {
      let msg =
        this.partOfRequired && this.partOf === ""
          ? "Please select value for previous level."
          : "No options available."
      return this.isLoading ? "loading options..." : msg
    },
    byPoint() {
      return this.partOf && this.partOf.startsWith('latitude:')
    },
  },
  methods: {
    search(query) {
      return this.hasMore ? this.debounceSearch(query) : ''
    },
    setNewValue(newValue) {
      let val = newValue[this.listValue] || ''
      let lbl = newValue[this.listLabel] || ''
      this.$emit("on-value-change", {
        selectedOption: newValue,
        field: this.fieldName,
        value: val,
        label: lbl
      })
      if (this.hiddenElement) {
        const el = document.getElementById(this.hiddenElement)
        if (el) {
          el.value = newValue[this.listValue]
        }
      }
    },
    getOptions(query) {
      if (!this.partOfRequired || this.partOf.length > 0) {
        if (query.length > 2 || query.length == 0) {
          this.searchFor = query
        }
        if (this.filter != this.lastFilter) {
          this.lastFilter = this.filter
          this.isLoading = true
          siloCalloutService.callOut(this.filter, this.processResult, this.handleError)
        }
      } else {
        this.listOptions = []
      }
    },
    processResult(rep){
      this.listOptions = rep.data.features.sort((a, b) => (a[this.listLabel] > b[this.listLabel]) ? 1 : -1)
      this.hasMore = rep.data.is_more_result
      if (this.byPoint){
        let point = {}
        point[this.listLabel] = 'Use selected Point'
        point[this.listValue] = this.partOf
        this.listOptions.push(point)
      }
      this.isLoading = false
    },
    handleError(err) {
      this.isLoading = false
    },
  },
  watch: {
    value(newVal, oldVal) {
      if (newVal && newVal !== oldVal) {
        this.setNewValue(newVal)
      }
    },
    partOf(newVal) {
      this.value = {}
      this.getOptions("")
    },
    initialValue(newVal) {
      this.value = newVal
    },
  },
  mounted() {
    this.debounceSearch = debounce((query) => this.getOptions(query), 1000)
    this.getOptions("")
    if (this.initialValue) {
      this.value = this.initialValue
    }
  },
  props: {
    initialValue: {
      type: Object,
      required: false,
    },
    hiddenElement: {
      type: String,
      required: false,
    },
    partOf: {
      type: String,
      required: false,
      default: "",
    },
    partOfRequired: {
      type: Boolean,
      required: false,
      default: false,
    },
    countryCode: {
      type: String,
      required: true,
    },
    level: {
      type: String,
      required: true,
    },
    fieldName: {
      type: String,
      required: true,
    },
    valueField: { 
      // this will allow us to change what piece of the option 
      // is returned, and used to look up the selected item
      type: String,
      required: false,
      default: 'id',
    },
  },
}
</script>

<style lang="scss">
  .multiselector {
    min-width: 14rem;
    max-width: 100%;
  }
</style>

